import { defineNuxtPlugin, useAuth } from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  const auth = useAuth();
  nuxtApp.hook("app:mounted", () => {
    window.addEventListener("focus", auth.updateSelectedIdentityCookie);
  });
});
